import request from '@/utils/request'

export function list(data) {
  return request({
    url: '/api/sms/list',
    method: 'post',
    data
  })
}
